import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { InspirationChoiceTile } from "web_myplann/Inspiration/Components/InspirationChoiceTile";

type Props = {
	label: string;
	rate: string;
	years: string;
	age?: string;
	selected: boolean;
	onClick: () => void;
};

export const EarlyFreedomScenarioCard: FC<Props> = ({
	label,
	rate,
	years,
	age,
	selected,
	onClick,
}) => {
	const theme = useTheme();

	return (
		<InspirationChoiceTile selected={selected} onClick={onClick}>
			<Typography
				variant="button"
				mb={0.4}
				color={selected ? theme.palette.blue.main : theme.palette.grey[500]}
				textTransform="uppercase"
				textAlign="center"
			>
				{label}
			</Typography>
			<Typography variant="hint" color={theme.palette.grey[500]} tabular>
				{rate}
			</Typography>
			<Typography
				variant="subtitle3"
				color={selected ? theme.palette.blue.main : theme.palette.grey[900]}
				tabular
				mt={0.6}
			>
				{years}
			</Typography>
			{age && (
				<Typography
					variant="hint"
					color={theme.palette.grey[500]}
					tabular
					mt={0.2}
				>
					{age}
				</Typography>
			)}
		</InspirationChoiceTile>
	);
};
